import { ExecutorGeolocationPayload } from '@/pages/Vaccination/components/task/types';
import {
  GEOLOCATION_ERROR,
  getGeolocationUndefinedText,
} from '@/shared/vaccination/enums';
import { getCurrentCoordinates } from '@/utils/getCoordinates';

/**
 * Геолокация контролера для отметки особей. Если местоположение определить не удалось,
 * вместо координат передаётся причина, а контролер получает предупреждение — сохранение не блокируется.
 */
export const getExecutorGeolocation = async (
  onUndefined?: (text: string) => void,
): Promise<ExecutorGeolocationPayload> => {
  const { position, error } = await getCurrentCoordinates();

  if (position) {
    return {
      executorGeolocation: {
        type: 'Point',
        coordinates: [position.coords.latitude, position.coords.longitude],
      },
      geolocationAccuracyM: position.coords.accuracy,
    };
  }

  const geolocationError = error ?? GEOLOCATION_ERROR.POSITION_UNAVAILABLE;
  onUndefined?.(getGeolocationUndefinedText(geolocationError));

  return {
    executorGeolocation: null,
    geolocationError,
  };
};
